<template>
  <validation-observer ref="simpleRules">
    <b-card-code title="Area Management List">
      <b-button
        v-show="isAdmin"
        variant="outline-primary"
        class="bg-gradient-primary mt-2"
        style="position: absolute;right: 15px;top: -10px;"
        type="submit"
        @click="addItem"
      >
        <span class="align-middle">Add Area</span>
      </b-button>
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </div>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="dataRows"
        :is-loading="loading"
        style-class="vgt-table striped"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm }"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <div
          slot="emptystate"
          align="center"
        >
          No Data
        </div>
        <template
          slot="table-row"
          slot-scope="props"
        >

          <!-- Column: Status -->
          <span
            v-if="props.column.field === 'Status'"
            v-b-modal.modal-center
            :title="props.row.Komentar"
          >
            <b-badge :variant="statusVariant(props.row.Status)">
              {{ props.row.Status }}
            </b-badge>
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'Action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none nopad"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-show="isAdmin"
                  @click="validateData({id:props.row.id, name: props.row.AreaName, note: props.row.AreaNote, order: 'edit'})"
                >
                  <feather-icon
                    icon="EditIcon"
                    class="mr-50"
                  />
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-show="isAdmin"
                  @click="validateData({id:props.row.id, name: props.row.AreaName, order: 'delete'})"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class="mr-50"
                  />
                  <span>Remove</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template
          slot="pagination-bottom"
          slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Showing 1 to
              </span>
              <b-form-select
                v-model="pageLength"
                :options="['5','10','20','50']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
              />
              <span class="text-nowrap"> of {{ totalPage }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="totalPage"
                :per-page="totalRow"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <b-modal
        id="modal-center"
        ref="modal"
        v-model="modalShow"
        centered
        title="Form Add Area"
        cancel-title="Cancel"
        ok-title="Add"
        @ok="validationForm"
      >
        <validation-provider
          #default="{ errors }"
          name="Name"
          rules="required"
        >
          <b-form-group
            label="Area Name"
            label-for="Name"
          >
            <b-form-input
              id="Name"
              v-model="areaName"
              placeholder="Input Area Name"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>

        <validation-provider
          #default="{ errors }"
          name="Note"
          rules="required"
        >
          <b-form-group
            label="Area Note"
            label-for="Note"
          >
            <b-form-input
              id="Note"
              v-model="areaNote"
              placeholder="Input Area Note"
            />
          </b-form-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-modal>

      <b-modal
        id="modal-detete"
        ref="modaldelete"
        v-model="modalDelete"
        centered
        :title="`${selectedItem.order === 'edit' ? 'Edit' : 'Remove'} Equipment & Chemical`"
        cancel-title="Cancel"
        :ok-title="selectedItem.order === 'delete' ? 'Remove' : 'Save'"
        @ok="execute"
      >
        <div v-show="selectedItem.order === 'edit'">
          <validation-provider
            #default="{ errors }"
            name="Area Name"
            rules="required"
          >
            <b-form-group
              label="Area Name"
              label-for="Area Name"
            >
              <b-form-input
                id="Area Name"
                v-model="areaName"
                placeholder="Input Area Name"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>

          <validation-provider
            #default="{ errors }"
            name="Note"
            rules="required"
          >
            <b-form-group
              label="Area Note"
              label-for="Note"
            >
              <b-form-input
                id="Note"
                v-model="areaNote"
                placeholder="Input Area Note"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </div>
        <span v-show="selectedItem.order === 'delete'"> Remove item <b> {{ selectedItem.name }} </b> </span>
      </b-modal>
    </b-card-code>
  </validation-observer>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BLink,
  VBTooltip,
  VBModal,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, numeric } from '@validations'
import axios from '@axios'
import dayjs from 'dayjs'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    numeric,
    BLink,
    BCardCode,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    VBModal,
    VBTooltip,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  data() {
    return {
      pageTitle: '',
      loading: true,
      pageLength: 10,
      dir: false,
      totalPage: 0,
      isAdmin: false,
      totalRow: 0,
      page: 0,
      fromPage: 0,
      areaName: '',
      areaNote: '',
      toPage: 0,
      modalShow: false,
      modalDelete: false,
      selectedItem: {},
      // codeBasic,
      columns: [
        {
          label: 'Area Name',
          field: 'AreaName',
        },
        {
          label: 'Area Note',
          field: 'AreaNote',
        },
        {
          label: 'Created At',
          field: 'CreatedAt',
        },
        {
          label: 'Updated At',
          field: 'UpdateddAt',
        },
        {
          label: 'Action',
          field: 'Action',
        },
      ],
      dataRows: [
        {
          AreaName: '',
          CreatedAt: '',
          UpdateddAt: '',
          authorize: false,
          Status: '',
          Action: '',
          Komentar: [],
        },
      ],
      searchTerm: '',
      Status: [
        {
          1: 'Procces',
          2: 'Proses',
          3: 'Rejected',
          4: 'Resigned',
          5: 'Applied',
        },
        {
          1: 'light-primary',
          2: 'light-success',
          3: 'light-danger',
          4: 'light-warning',
          5: 'light-info',
        },
      ],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Procces: 'light-primary',
        Proses: 'light-success',
        Failed: 'light-danger',
        Resigned: 'light-warning',
        Process: 'light-info',
        /* eslint-enable key-spacing */
      }
      return status => statusColor[status]
    },
  },
  watch: {
    $route() {
      this.getDisposisi()
    },
    pageLength() {
      this.getDisposisi()
    },
  },
  mounted() {
    this.getDisposisi()
  },
  created() {
    if (store.state.userData.user.role === '1') {
      this.isAdmin = true
    } else {
      this.isAdmin = false
    }
  },
  methods: {
    detailDisposisi(e) {
      window.location.href = `detail-disposisi/${e}`
    },
    validationForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.add()
          this.$refs.modal.hide()
        }
      })
    },
    addItem() {
      this.areaName = ''
      this.areaNote = ''
      this.modalShow = true
    },
    validateData(val) {
      this.modalDelete = !this.modalDelete
      this.areaName = val.name
      this.areaNote = val.note
      this.selectedItem = val
    },
    execute() {
      if (this.selectedItem.order === 'delete') {
        this.delete()
      } else {
        this.edit()
      }
    },
    async getDisposisi(val) {
      const { data } = await axios.get('/area', {
        params: {
          // page: this.page === 0 ? null : this.page,
        },
      })
      this.totalPage = data.data.length
      this.totalRow = this.pageLength
      this.fromPage = data.from
      this.toPage = data.to
      if (data.total !== 0) {
        this.dataRows = data.data.map(e => ({
          id: e.id,
          AreaName: e.area || '-',
          AreaNote: e.keterangan || '-',
          CreatedAt: dayjs(e.created_at).format('DD-MM-YYYY') || '-',
          UpdateddAt: dayjs(e.updated_at).format('DD-MM-YYYY') || '-',
          // Status: e.disposition !== null ? e.status.name : '-',
          Action: '',
        }))
      } else {
        this.dataRows = []
      }
      this.loading = false
      //   .catch(error => {
      //     console.log(error)
      //   })
    },

    async add() {
      await axios
        .post('area', {
          area: this.areaName,
          keterangan: this.areaNote,
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          this.getDisposisi()
        })
        .catch(error => {
          this.errorLog = error
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },

    async delete() {
      await axios
        .delete(`area/${this.selectedItem.id}`)
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          this.getDisposisi()
        })
        .catch(error => {
          this.errorLog = error
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },
    async edit() {
      await axios
        .put('area', {
          area: this.areaName,
          keterangan: this.areaNote,
          id: this.selectedItem.id,
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          this.getDisposisi()
        })
        .catch(error => {
          this.errorLog = error
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },
  },
}
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
.nopad {
  padding: 0;
}
.link-no {
  border-bottom: solid 1px #c5c5c5;
  padding-bottom: 3px;
  cursor: pointer;
}
</style>
